import { render, staticRenderFns } from "./QuotesByStatus.vue?vue&type=template&id=027f1649&scoped=true&"
import script from "./QuotesByStatus.vue?vue&type=script&lang=js&"
export * from "./QuotesByStatus.vue?vue&type=script&lang=js&"
import style0 from "./QuotesByStatus.vue?vue&type=style&index=0&id=027f1649&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027f1649",
  null
  
)

export default component.exports